import type {
  CoreInquiryPayload,
  CoreInquiryResponseSingle,
} from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Create an inquiry for a store.
 *
 * @endpoint POST /api/stores/{storeDomain}/inquiries
 * @scope store
 * @see https://flecto.dev/api-4724243
 */
export async function createInquiry(
  storeDomain: string,
  inquiry: CoreInquiryPayload
): Promise<CoreInquiryResponseSingle> {
  const body: CoreInquiryPayload = inquiry

  const response = await api.post<CoreInquiryResponseSingle>(
    `/api/stores/${storeDomain}/inquiries`,
    body
  )

  return response.data
}
